/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import Vue from 'vue'
import VueRouter from 'vue-router'


import ClockInOut from '@/modules/TimeClock/index.vue';

// const Main = () => import('@/modules/Layout/index.vue');

const FindLocation = () => import('@/modules/Authentication/components/FindLocation.vue');

const PageNotFound = () => import('../views/PageNotFound.vue');

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

let routes = [
  {
    path: '/location',
    name: 'authentication-find-location',
    component: FindLocation,
    props: true,
  },
	{
    path: '/',
    name: 'clockInOut',
    component: ClockInOut,
  },
  // {
  //   path: '',
  //   name: 'clockInOut',
  //   component: ClockInOut,
  // },
  {
    path: '*',
    name: 'pagenotfound',
    component: PageNotFound,
  },

]

// routes = routes.concat(backofficeRoutes);
// routes = routes.concat(loginRoutes);
// routes = routes.concat(SignUpRoutes);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})


// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`) == null) {
//       console.log('i got here', to , from)
//       if (from && from.name !== 'signUp' || from.name !== 'backOfficeLogin') {
//         next({path: 'login'})
//       } 

//     } else {
//       next()
//     }
//   } else {
//     next() // make sure to always call next()!
//   }
// })



export default router